'use strict';

$(function () {
  $('.menu-toggle').click(function () {
    $(this).toggleClass('clicked');
    $('.nav--home, .nav--pages').slideToggle();
  });
});